import { render, staticRenderFns } from "./news-single-commentary.vue?vue&type=template&id=416d02a1&scoped=true&"
import script from "./news-single-commentary.vue?vue&type=script&lang=js&"
export * from "./news-single-commentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d02a1",
  null
  
)

export default component.exports